import {type I18n, type MessageDescriptor} from '@lingui/core'

import {
  ClassroomApiError,
  classroomErrorMessage,
} from '#/state/queries/classrooms'
import * as Toast from '#/components/Toast'

/** A failed classroom call, said in the toast in plain words. */
export function showClassroomError(i18n: I18n, error: unknown) {
  Toast.show(
    classroomErrorMessage(
      // Only ever handed the module's own `msg` descriptors.
      d => i18n._(d as MessageDescriptor),
      error instanceof ClassroomApiError ? error.code : '',
    ),
    {type: 'error'},
  )
}

/** "Already handled.", for an ask somebody else answered or withdrew first. */
export function noRequestMessage(i18n: I18n): string {
  return classroomErrorMessage(d => i18n._(d as MessageDescriptor), 'NoRequest')
}
